export default __webpack_public_path__ + "static/media/John.365da390.jpg";